import React, { useContext } from "react";
import { ContextEngine } from "../../engine/ContextEngine";

// Import all possible view-mode components
import NormalBottom from "./content/NormalBottom";
import TimeMachine from "./content/TimeMachine";
import DebugConsole from "./content/DebugConsole";
import AuditStream from "./content/AuditStream";
import TractumSvgEditor from "./content/TractumSvg";

import "./Bottom1.css";

const Bottom = () => {
  const { context, updateContext } = useContext(ContextEngine);

  // If bottom panel hidden → render nothing
  if (!context.panelVisibility?.bottom) return null;
  const isMaximized = context.panelVisibility?.bottomMaximized;

  const toggleMaximize = () => {
    updateContext("panelVisibility.bottomMaximized", !isMaximized);
  };

  // Current view mode (fallback to 'normal')
  const mode = context.view?.mode || "normal";

  // Map modes to components
  const modeMap = {
    normal: NormalBottom,
    timeTravel: TimeMachine,
    tractumDebug: DebugConsole,
    audit: TractumSvgEditor,
  };

  const BottomContent = modeMap[mode] || NormalBottom;

  const { left: leftVisible, right: rightVisible, bottom: bottomVisible } = context.panelVisibility;

  return (
    <div className={`bottom-panel-wrapper ${isMaximized ? 'maximized' : ''}`}>

      {/* ----------------- TOOLBAR ----------------- */}
      
      <div className="bottom-toolbar" onDoubleClick={toggleMaximize} style={{ cursor: 'pointer', justifyContent: 'space-between' }}>

        <div style={{ display: 'flex', gap: '6px' }}>
          {bottomVisible !== undefined && (
            <button onClick={() => updateContext("panelVisibility.bottom", !bottomVisible)}>
              {bottomVisible ? "Hide Bottom" : "Show Bottom"}
            </button>
          )}

          {leftVisible !== undefined && (
            <button onClick={() => updateContext("panelVisibility.left", !leftVisible)}>
              {leftVisible ? "Hide Left" : "Show Left"}
            </button>
          )}
          {rightVisible !== undefined && (
            <button onClick={() => updateContext("panelVisibility.right", !rightVisible)}>
              {rightVisible ? "Hide Right" : "Show Right"}
            </button>
          )}

          <button onClick={() => updateContext("view.mode", "normal")}>Normal</button>
          <button onClick={() => updateContext("view.mode", "audit")}>Audit</button>
          <button onClick={() => updateContext("view.mode", "timeTravel")}>Time Travel</button>
          <button onClick={() => updateContext("view.mode", "tractumDebug")}>Debug</button>
        </div>
        <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
          <span style={{ fontSize: '11px', fontWeight: 'bold', marginRight: '10px' }}>
            {isMaximized ? "🗗 MAXIMIZED" : "🗖 CONSOLE"}
          </span>
          <button onClick={toggleMaximize}>{isMaximized ? "Restore" : "Maximize"}</button>
          {/* NEW: CLOSE BUTTON */}
          <button 
            onClick={() => updateContext("panelVisibility.bottom", false)}
            style={{ background: '#e74c3c', color: 'white', fontWeight: 'bold', border: 'none', padding: '2px 8px' }}
            title="Close Console"
          >
            ✕
          </button>
        </div>
      </div>
        {/* ----------------- CONTENT ----------------- */}
      <div className="bottom-content">
        <BottomContent 
          context={context} 
          onClose={() => updateContext("view.mode", "normal")} 
        />
      </div>
    </div>
  );
};

export default Bottom;
